import { Stack, Typography, Box } from "@mui/material";
import { PrimaryFormDateOfBirth, StyledButton } from "react-common-ui-library";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import {
  CONTAINED,
  CONTINUE_BUTTON,
  P_REGULAR_SEMI_BOLD,
  SUBMIT,
  USER_NAME_LABEL,
  USER_NAME_VALUE,
} from "../../../Constants/CommonConstants";
import { manageLoginSelector } from "../../../Selectors/LoginSelector";
import {
  StyledEnableAccountContinueButtonBox,
  StyledEnableAccountDOBBox,
  StyledEnableAccountInputBox,
} from "../../../Styles/Login/EnableYourAccount/EnableYourAccountStyles";

/**
 * @description Enable your account form components.
 * @returns {ReactNode} Render the Username static text and Date of birth inputs with submit button.
 */
const EnableYourAccountFormElements = () => {
  const intl = useIntl();
  const { userName } = useSelector((state) => manageLoginSelector(state));

  return (
    <Stack spacing={{ xs: 9, md: 10 }}>
      <StyledEnableAccountInputBox>
        <Stack spacing={{ xs: 1.75, md: 4 }}>
          <Stack spacing={1.5}>
            <Typography variant={P_REGULAR_SEMI_BOLD} id={USER_NAME_LABEL}>
              {intl.formatMessage({ id: USER_NAME_LABEL })}
            </Typography>
            <Typography id={USER_NAME_VALUE}>{userName}</Typography>
          </Stack>
          <StyledEnableAccountDOBBox>
            <PrimaryFormDateOfBirth />
          </StyledEnableAccountDOBBox>
        </Stack>
      </StyledEnableAccountInputBox>
      <StyledEnableAccountContinueButtonBox>
        <Box>
          <StyledButton
            variant={CONTAINED}
            id={CONTINUE_BUTTON}
            fullWidth
            type={SUBMIT}
          >
            {intl.formatMessage({ id: CONTINUE_BUTTON })}
          </StyledButton>
        </Box>
      </StyledEnableAccountContinueButtonBox>
    </Stack>
  );
};

export default EnableYourAccountFormElements;
